import axios from "axios";
import {
	interceptAutoRefreshAuthToken,
	interceptInsertAuthToken,
} from "./interceptors";

import {
	GetEndpoints,
	PostEndpoints,
	PutEndpoints,
	DeleteEndpoints,
} from "./types";

export const apiUrl = `https://alto-cero-backend-multi-property-fwh3d3cybgdrdke5.southeastasia-01.azurewebsites.net/api`
// const host = window.location.hostname;
// export const apiUrl =
// 	import.meta.env.VITE_API_BASE_URL ||
// 	`${window.location.protocol}//${host}/api`;

export const httpClient = axios.create({ baseURL: apiUrl });
interceptInsertAuthToken(httpClient);
interceptAutoRefreshAuthToken(httpClient);

export async function get<Path extends keyof GetEndpoints>(path: Path) {
	const response = await httpClient.get<GetEndpoints[Path]["responseBody"]>(
		path
	);
	return response.data;
}

export async function post<Path extends keyof PostEndpoints>(
	path: Path,
	body: PostEndpoints[Path]["requestBody"],
	asForm: boolean = false
) {
	const response = await httpClient.post<PostEndpoints[Path]["responseBody"]>(
		path,
		transformBody(body, asForm)
	);
	return response.data;
}

export async function put<Path extends keyof PutEndpoints>(
	path: Path,
	body: PutEndpoints[Path]["requestBody"]
) {
	const response = await httpClient.put<PutEndpoints[Path]["responseBody"]>(
		path,
		body
	);
	return response.data;
}

export async function callDelete<Path extends keyof DeleteEndpoints>(
	path: Path
) {
	const response = await httpClient.delete<
		DeleteEndpoints[Path]["responseBody"]
	>(path);
	return response.data;
}

function transformBody(body: any, asForm: boolean) {
	if (asForm) {
		return new URLSearchParams(body);
	}
	return body;
}

export async function swrFetcher(args: any[]) {
	const [path, params] = args;
	const response = await httpClient.get(path, { params });
	return response.data;
}
